export default "__VITE_ASSET__5952d551__"